<div class="logged-in-view h-full overflow-y-auto">
    <div class="w-full flex flex-col md:flex-row justify-between mb-8 gap-4">
        <div class="flex flex-col gap-4">
            <h1 class="text-app-primary-10">Profil</h1>
        </div>
    </div>
    <mat-tab-group class="mt-8 w-full" [mat-align-tabs]="'left'" [mat-stretch-tabs]="false">
        <mat-tab label="Persönliche Daten">
            <div class="pt-6">
                <form [formGroup]="profileForm" class="space-y-6">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div class="flex flex-col gap-2">
                            <label>Anrede</label>
                            <mat-select formControlName="genderId" class="custom-select">
                                <mat-option [value]="''">Bitte wählen</mat-option>
                                @for (gender of genders; track gender.id) {
                                    <mat-option [value]="gender.id">{{ gender.name | gender }}</mat-option>
                                }
                            </mat-select>
                        </div>
                        <div class="flex flex-col gap-2">
                            <label>Vorname</label>
                            <input matInput type="text" formControlName="firstName">
                        </div>
                        <div class="flex flex-col gap-2">
                            <label>Nachname</label>
                            <input matInput type="text" formControlName="lastName">
                        </div>
                        <div class="flex flex-col gap-2">
                            <label>Geburtsdatum</label>
                            <div class="relative">
                                <input matInput [matDatepicker]="picker" formControlName="dateOfBirth" class="w-full">
                                <mat-datepicker-toggle [for]="picker" matIconSuffix class="absolute right-0 top-1/2 -translate-y-1/2"></mat-datepicker-toggle>
                                <mat-datepicker #picker  [touchUi]="isMobile"></mat-datepicker>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <label>E-Mail</label>
                            <input matInput type="text" formControlName="email">
                        </div>
                        <div class="flex flex-col gap-2">
                            <label>Mobilnummer</label>
                            <input matInput type="text" formControlName="mobileNumber">
                        </div>
                        <div class="flex flex-col gap-2">
                            <label>Telefonnummer</label>
                            <input matInput type="text" formControlName="phoneNumber">
                        </div>
                    </div>
                    <div class="flex justify-end pt-4">
                        <button class="btn primary-button" (click)="onSubmitProfile()">Änderungen speichern</button>
                    </div>
                </form>
            </div>
        </mat-tab>
        <mat-tab label="Ausweisdokumente">
            <div class="pt-6 space-y-8">
                <div class="p-4 bg-app-background-20 rounded-lg text-xs text-app-secondary-10 border-l-4 border-app-secondary-10">
                    Die Ausweisdokumente werden mit Ihrem behandelnden Arzt geteilt, sodass eine Identifizierung möglich ist.
                </div>

                @if (isLoadingIdFiles) {
                    <div class="flex flex-col items-center justify-center py-12 gap-4">
                        <i class="fa-solid fa-circle-notch fa-spin text-4xl text-app-primary-10"></i>
                        <p class="text-app-secondary-10 animate-pulse">Lade Ausweisdokumente...</p>
                    </div>
                } @else if (showUploadFields || !idFiles || idFiles.length === 0) {
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div class="flex flex-col gap-4">
                            <label class="text-app-primary-20 font-medium">Vorderseite des Personalausweises</label>
                            @if (idDocuments.front.fileData == '') {
                                <app-file-upload [useBase64Upload]="true" [base64WithInfos]="true" (fileSelected)="onFileSelectedFront($event)" [allowedMimeTypes]="['image/jpeg', 'image/png']" class="bg-app-background-20 rounded-lg p-6 border-2 border-dashed border-app-primary-10/10"></app-file-upload>
                            } @else {
                                <div class="relative group aspect-video overflow-hidden rounded-lg shadow-md border border-gray-200">
                                    <button class="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white w-10 h-10 flex items-center justify-center rounded-full shadow-lg z-10 transition-all transform hover:scale-110" (click)="removeFile('front')">
                                        <i class="fa-solid fa-trash-can text-sm"></i>
                                    </button>
                                    <img [src]="'data:image/jpeg;base64,' + idDocuments.front.fileData" alt="Vorderseite" class="w-full h-full object-cover">
                                </div>
                            }
                        </div>
                        <div class="flex flex-col gap-4">
                            <label class="text-app-primary-20 font-medium">Rückseite des Personalausweises</label>
                            @if (idDocuments.back.fileData == '') {
                                <app-file-upload [useBase64Upload]="true" [base64WithInfos]="true" (fileSelected)="onFileSelectedBack($event)" [allowedMimeTypes]="['image/jpeg', 'image/png']" class="bg-app-background-20 rounded-lg p-6 border-2 border-dashed border-app-primary-10/10"></app-file-upload>
                            } @else {
                                <div class="relative group aspect-video overflow-hidden rounded-lg shadow-md border border-gray-200">
                                    <button class="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white w-10 h-10 flex items-center justify-center rounded-full shadow-lg z-10 transition-all transform hover:scale-110" (click)="removeFile('back')">
                                        <i class="fa-solid fa-trash-can text-sm"></i>
                                    </button>
                                    <img [src]="'data:image/jpeg;base64,' + idDocuments.back.fileData" alt="Rückseite" class="w-full h-full object-cover">
                                </div>
                            }
                        </div>
                    </div>
                    <div class="flex justify-between items-center pt-4 border-b border-app-primary-10/10 pb-8">
                        @if (idFiles && idFiles.length > 0) {
                            <button class="btn secondary-button" (click)="toggleUpload(false)">Abbrechen</button>
                        } @else {
                            <div></div>
                        }
                        <button class="btn primary-button" (click)="onSubmitIdDocuments()">Ausweisdokumente aktualisieren</button>
                    </div>
                } @else {
                    <!-- Anzeige der bereits hochgeladenen Dokumente anstatt der Upload Felder -->
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                        @for (file of idFiles; track file.id) {
                            @if (file && file.base46) {
                                <div class="flex flex-col gap-4">
                                    <label class="text-app-primary-20 font-medium">
                                        @if (file.fileName.includes('back')) {
                                            <span>Rückseite des Personalausweises</span>
                                        } @else {
                                            <span>Vorderseite des Personalausweises</span>
                                        }
                                    </label>
                                    <div class="relative group aspect-video overflow-hidden rounded-lg shadow-md border border-app-primary-10/10 bg-white max-w-[40rem]">
                                        <div class="absolute top-2 right-2 flex gap-2 z-10">
                                            <button class="bg-app-primary-10 hover:bg-app-primary-20 text-white w-10 h-10 flex items-center justify-center rounded-full shadow-lg transition-all transform hover:scale-110" (click)="triggerDownload(file)" title="Download">
                                                <i class="fa-solid fa-download text-sm"></i>
                                            </button>
                                            <button class="bg-app-primary-10 hover:bg-app-primary-20 text-white w-10 h-10 flex items-center justify-center rounded-full shadow-lg transition-all transform hover:scale-110" (click)="openPermissions(file.id)" title="Berechtigungen">
                                                <i class="fa-solid fa-share text-sm"></i>
                                            </button>
                                        </div>
                                        <img [src]="'data:image/png;base64,' + file.base46" alt="file" class="w-full h-full object-cover">

                                        <!-- Overlay für Berechtigungen -->
                                        @if (openPermissionsId == file.id) {
                                            <div class="absolute inset-0 bg-white/95 z-20 p-4 overflow-y-auto animate-fade-in">
                                                <div class="flex justify-between items-center mb-4">
                                                    <h4 class="text-sm font-medium text-app-primary-20">Berechtigungen verwalten</h4>
                                                    <button (click)="openPermissions('')" class="text-app-secondary-10 hover:text-app-primary-10">
                                                        <i class="fa-solid fa-times"></i>
                                                    </button>
                                                </div>
                                                @if (file.permissionsGranted && file.permissionsGranted.length > 0) {
                                                    <div class="space-y-2 mb-4">
                                                        @for (granted of file.permissionsGranted; track granted.id) {
                                                            <div class="flex justify-between items-center p-2 bg-app-background-20 rounded border border-app-primary-10/5">
                                                                <span class="text-xs"> {{ granted.doctor.title ? granted.doctor.title + ' ' : '' }}{{ granted.doctor.firstName }} {{ granted.doctor.lastName }}</span>
                                                                <button class="text-red-500 hover:text-red-600 p-1" (click)="deletePermission(granted.id)" title="Berechtigung entziehen">
                                                                    <i class="fa-solid fa-times text-xs"></i>
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                <div class="flex flex-col items-center gap-2">
                                                    <p class="text-[10px] text-app-secondary-10">Berechtigung für einen Arzt hinzufügen</p>
                                                    <button class="w-8 h-8 flex items-center justify-center rounded-full bg-app-primary-10 text-white hover:bg-app-primary-10/90 transition-colors"
                                                            (click)="openPermissionModal(file, file.fileName.includes('back') ? 'Rückseite' : 'Vorderseite')">
                                                        <i class="fa-solid fa-plus text-xs"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div class="text-[10px] text-app-secondary-10 px-1">
                                        <p>Hochgeladen am {{ file.uploadedAt | date: 'dd.MM.yyyy HH:mm' }} Uhr</p>
                                    </div>
                                </div>
                            }
                        }
                    </div>
                    <div class="flex justify-end pt-4 border-b border-app-primary-10/10 pb-8">
                        <button class="btn secondary-button flex items-center gap-2" (click)="toggleUpload(true)">
                            <i class="fa-solid fa-plus"></i>
                            Neue Dokumente hochladen
                        </button>
                    </div>
                }
            </div>
        </mat-tab>

        <mat-tab label="Adressen">
            <div class="pt-6 space-y-8">
                <div>
                    <div class="text-app-primary-20 font-medium mb-4">Rechnungsadresse</div>
                    <form [formGroup]="invoiceAddressForm">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div class="flex flex-col gap-2">
                                <label>Straße</label>
                                <input matInput type="text" formControlName="street">
                            </div>
                            <div class="flex flex-col gap-2">
                                <label>Hausnummer</label>
                                <input matInput type="text" formControlName="houseNumber">
                            </div>
                            <div class="flex flex-col gap-2">
                                <label>Wohnort</label>
                                <input matInput type="text" formControlName="city">
                            </div>
                            <div class="flex flex-col gap-2">
                                <label>PLZ</label>
                                <input matInput type="text" formControlName="zipCode">
                            </div>
                        </div>
                    </form>
                </div>

                <div>
                    <div class="text-app-primary-20 font-medium mb-4">Lieferadresse</div>
                    <form [formGroup]="deliveryAddressForm">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div class="flex flex-col gap-2">
                                <label>Straße</label>
                                <input matInput type="text" formControlName="street">
                            </div>
                            <div class="flex flex-col gap-2">
                                <label>Hausnummer</label>
                                <input matInput type="text" formControlName="houseNumber">
                            </div>
                            <div class="flex flex-col gap-2">
                                <label>Wohnort</label>
                                <input matInput type="text" formControlName="city">
                            </div>
                            <div class="flex flex-col gap-2">
                                <label>PLZ</label>
                                <input matInput type="text" formControlName="zipCode">
                            </div>
                        </div>
                    </form>
                </div>

                <div class="flex justify-end pt-4 border-b border-app-primary-10/10 pb-8">
                    <button class="btn primary-button" (click)="onSubmitProfile()">Adressen aktualisieren</button>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Standard Apotheke">
            <div class="pt-6 space-y-6">
                <div class="flex flex-col gap-2">
                    <label>Apothekenauswahl</label>
                    <mat-select [formControl]="pharmacyIdFormControl" (selectionChange)="checkPharmacyDisabledState()" class="custom-select">
                        <mat-option [value]="''">Bitte wählen</mat-option>
                        <mat-option [value]="'custom'">Eigene Apotheke</mat-option>
                        <mat-option [value]="'none'">Keine Apotheke auswählen (Rezept mir direkt zustellen)</mat-option>
                        @for (pharmacy of pharmacyList; track pharmacy.id) {
                            <mat-option [value]="pharmacy.id">{{ pharmacy.name }}</mat-option>
                        }
                    </mat-select>
                </div>

                @if (pharmacyIdFormControl.value !== '' && pharmacyIdFormControl.value !== 'none') {
                    <div class="p-4 bg-app-background-20 rounded-lg text-xs text-app-secondary-10 border-l-4 border-app-secondary-10">
                        Wenn Sie eine eigene Apotheke wählen, fallen Rezeptversandkosten an.
                    </div>
                    <form [formGroup]="customPharmacyForm">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div class="flex flex-col gap-2">
                                <label>Apothekenname *</label>
                                <input matInput placeholder="Apothekenname" formControlName="name">
                            </div>
                            <div class="flex flex-col gap-2">
                                <label>Straße *</label>
                                <input matInput placeholder="Musterstraße" formControlName="street">
                            </div>
                            <div class="flex flex-col gap-2">
                                <label>Hausnummer *</label>
                                <input matInput placeholder="1" formControlName="houseNumber">
                            </div>
                            <div class="flex flex-col gap-2">
                                <label>PLZ *</label>
                                <input matInput placeholder="12345" formControlName="zipCode">
                            </div>
                            <div class="flex flex-col gap-2">
                                <label>Ort *</label>
                                <input matInput placeholder="Musterhausen" formControlName="city">
                            </div>
                            <div class="flex flex-col gap-2">
                                <label>Telefonnummer *</label>
                                <input matInput placeholder="+49 123 4567890" formControlName="phoneNumber">
                            </div>
                        </div>
                        <div class="text-right text-[10px] text-app-secondary-10 mt-2">* Pflichtfelder</div>
                    </form>
                }

                @if (pharmacyIdFormControl.value === 'none' || pharmacyIdFormControl.value === '') {
                    <div class="p-4 bg-app-background-20 rounded-lg text-xs text-app-secondary-10 border-l-4 border-app-secondary-10">
                        Wenn Sie keine Apotheke auswählen, wird Ihnen das Rezept auf dem Postweg direkt an Ihre Adresse gesendet. Dadurch entstehen Versandkosten, die Ihnen beim Bezahlvorgang nach Rezeptfreigabe berechnet werden.
                    </div>
                }

                <div class="flex justify-end pt-4 border-b border-app-primary-10/10 pb-8">
                    <button class="btn primary-button" (click)="onSubmitPharmacy()">Apotheke aktualisieren</button>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Sicherheit">
            <div class="pt-6">
                <form [formGroup]="passwordForm" class="space-y-6">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div class="flex flex-col gap-2">
                            <label>Neues Passwort</label>
                            <input matInput type="password" placeholder="*****" formControlName="newPassword">
                        </div>
                        <div class="flex flex-col gap-2">
                            <label>Passwort wiederholen</label>
                            <input matInput type="password" placeholder="*****" formControlName="passwordConfirm">
                            @if (passwordForm.get('passwordConfirm')?.valid && passwordForm.get('newPassword')?.value !== passwordForm.get('passwordConfirm')?.value) {
                                <span class="text-red-500 text-xs mt-1">* Passwörter stimmen nicht überein</span>
                            }
                        </div>
                    </div>
                    <div class="flex justify-end pt-4 border-b border-app-primary-10/10 pb-8">
                        <button class="btn primary-button" (click)="onSubmitPassword()">Passwort aktualisieren</button>
                    </div>
                </form>
            </div>
        </mat-tab>

        <mat-tab label="Dokumente">
            <div class="pt-6">
                <app-patient-file-handling [patient]="patient"></app-patient-file-handling>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>
